export default {
    namespaced: true,
    state: {
        is_atlas: false,
        atlas_loaded: false,

        checked_selector: {},
        
        atlas_type: '',
    },
    mutations:{
        set_atlas_state(state, atlas_state) {
            state.is_atlas = atlas_state;
        },
        
        set_atlas_loaded(state, atlas_loaded) {
            state.atlas_loaded = atlas_loaded;
        },

        set_checked_selector(state, checked_selector) {
           state.checked_selector =  checked_selector
        },
    },
    actions: {
    },
    getters: {
        is_atlas: state => {
            return state.is_atlas;
        },
        
        atlas_loaded: state => {
            return state.atlas_loaded;
        },
        
        type: state => {
            return state.checked_selector.value;
        },
        
        text: state => {
            return state.checked_selector.text;
        },
    },

}